import ApplicationController from './application_controller';

export default class extends ApplicationController {
  /**
   * Toggles the next `tr` element.
   */
  toggle(event) {
    const button = event.target.closest('button');
    if (!(button instanceof HTMLButtonElement)) return;

    // Hide the tooltip because it remains persisted.
    $(button).tooltip('hide');

    const nextTr = this.element.nextElementSibling;
    if (nextTr) {
      nextTr.hidden = !nextTr.hidden;
    }
  }
}
